import React, { useState, useRef, useEffect } from 'react'
import {
  createStyles,
  makeStyles,
  withStyles,
  TextField,
  // RadioGroup,
  Box,
  Select,
  Button,
  InputLabel,
  CircularProgress,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  // Input,
  // FormHelperText,
  FormControl,
  Grid,
  MenuItem,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import { DatePicker } from '@material-ui/pickers'
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined'
import { ReactComponent as Exclamation } from 'src/mobile/assets/icons/profile_icon.svg'

import isValid from 'date-fns/isValid'
import { Prompt } from 'react-router-dom'
import format from 'date-fns/format'
import isAfter from 'date-fns/isAfter'
import { toast } from 'react-toastify'
import { omit, omitBy, isNull, isString, throttle } from 'lodash'
import { useTranslation } from 'react-i18next'
import { Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { updateUserInfo } from 'src/store/slices/authSlice'
import FocusError from './FocusError'
// import { ERadio } from 'src/mobile/themes/components/ETextField'
// import { ReactComponent as RightArrowIcon } from 'src/mobile/assets/icons/arrow-ios-right.svg'
// import SnackbarHelperText from 'src/mobile/components/SnackbarHelperText'
import {
  // LABEL_WIDTH,
  INPUT_WIDTH,
  MOBILE_INPUT_WIDTH,
  DIALING_CODES,
  ID_TYPES,
  BIRTHDAY_FORMAT,
  // SERVICE_PHONE_02,
} from 'src/utils/constant'
import {
  encryptId,
  parseValid,
  //  formatDialingCode,
  getBirthDate,
} from 'src/utils'
// import VerifyInfoButton from 'src/mobile/components/dialogButton/VerifyInfoButton'
import { oriSchema } from 'src/utils/schema'
import { useTranslateFormErrors } from 'src/hooks'
import FixedButtonWrapper from 'src/mobile/components/FixedButtonWrapper'

const useStyles = makeStyles((theme) =>
  createStyles({
    form: {
      backgroundColor: theme.palette.background.paper,
      paddingTop: theme.spacing(1),
      // paddingLeft: theme.spacing(2),
      [theme.breakpoints.down('xs')]: {
        paddingBottom: theme.spacing(12),
      },
    },
    submitButton: {
      height: theme.spacing(5),
    },
    textField: {
      marginBottom: theme.spacing(1.5),
      marginTop: theme.spacing(1),
    },
    radioGroup: {
      marginTop: theme.spacing(2),
      borderBottom: `1px solid ${theme.palette.grey[50]}`,
    },

    inputBorder: {
      border: '1px solid',
    },
    requiredText: {
      color: '#4B5563',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
    helperText: {
      marginLeft: 0,
      marginBottom: theme.spacing(0.5),
    },
    profileTip: {
      fontSize: 16,
      display: 'flex',
    },
    outlined: {
      display: 'flex',
      flexDirection: 'row-reverse',
      justifyContent: 'flex-end',
    },
    asterisk: {
      color: theme.palette.secondary.main,
    },
  }),
)

const initialValues = {
  dialingCode: DIALING_CODES[0].value,
  nameEn: '',
  nameCn: '',
  gender: '0',
  identifyId: '',
  identifyType: 1,
  placeOfIssuance: '',
  birthday: new Date(),
  phone: '',
  email: '',
  // whatsAppId: '',
  // weChatId: '',
  userStatus: '0',
}

const CustomDatePicker = withStyles((theme) => ({
  root: {
    'label + &': {
      display: 'inline-block',
      marginTop: theme.spacing(1),
      paddingBottom: 20,
      // marginLeft: theme.spacing(LABEL_WIDTH),
    },
    borderRadius: theme.spacing(1),
    border: '1px solid',
    borderColor: 'rgba(0, 0, 0, 0.23)',
    // height: theme.spacing(2.25),
    padding: theme.spacing(1.25),
    position: 'relative',
    backgroundColor: theme.palette.common.white,
    fontSize: theme.typography.body2.fontSize,
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
    '&:before': {
      border: 'none',
    },
    minWidth: theme.spacing(INPUT_WIDTH),
    [theme.breakpoints.down('xs')]: {
      minWidth: theme.spacing(MOBILE_INPUT_WIDTH),
    },
    '&.MuiInput-underline': {
      border: 'none',

      '&:before': {
        border: 'none',
      },
    },
    '&.MuiInput-underline ::before': {
      border: 'none',

      '&:before': {
        border: 'none',
      },
    },
  },
}))(DatePicker)

const UserInfoForm = ({ userInfo, onConfirm, onCancel, fromOrder }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const resolveRef = useRef(null)
  const rejectRef = useRef(null)
  // const whatsAppIdInputRef = useRef(null)
  const { t } = useTranslation()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('xs'))
  const { updateUserInfoStatus } = useSelector((state) => state.auth)
  const [open, setOpen] = useState(false)
  const schema = oriSchema(t).pick([
    'nameEn',
    'nameCn',
    'gender',
    'identifyType',
    'identifyId',
    'birthday',
    'placeOfIssuance',
    'email',
    'dialingCode',
    'phone',
    'userStatus',
    // 'weChatId',
    // 'whatsAppId',
  ])

  const handleConfirm = (values) => {
    onConfirm && onConfirm(values)
  }

  const handleClose = () => {
    setOpen(false)
    resolveRef.current = null
    rejectRef.current = null
  }
  const handleOpen = () => {
    setOpen(true)
  }

  const handleCancelSubmit = () => {
    rejectRef.current && rejectRef.current()
    handleClose()
  }

  const handleResolveSubmit = () => {
    resolveRef.current && resolveRef.current()
    handleClose()
  }

  const identifyPlaceholder = (identifyType) => {
    switch (identifyType) {
      case 1:
        return 'Z123456(7)'
      case 2:
        return '1234567(8)'
      case 3:
        return 'E12345678'
      default:
        return '440102198404289701'
    }
  }

  return (
    <>
      {/* <SnackbarHelperText type="helperText">
        {t('tips.update_user_info', { phone: SERVICE_PHONE_02 })}
        {'\n'}
        {t('validation.form_with_mark_required')}
      </SnackbarHelperText> */}
      <Typography color="secondary" className={classes.profileTip}>
        <Exclamation />
        {t('profile.add_profile_tip')}
      </Typography>
      <Formik
        initialValues={{
          ...initialValues,
          ...omitBy(userInfo, isNull),
          userStatus: userInfo?.userStatus === '1' ? true : false,
          birthday: isString(userInfo?.birthday)
            ? parseValid(userInfo?.birthday, BIRTHDAY_FORMAT, new Date())
            : null,
          // whatsAppId: userInfo?.whatsAppId || userInfo?.phone || '',
        }}
        // from add order page user info form should validate phone and email field.
        validationSchema={fromOrder ? schema.omit(['email']) : schema.omit(['phone', 'dialingCode', 'email'])}
        onSubmit={throttle(async (values, actions) => {
          if (updateUserInfoStatus === 'pending') return
          // if user info is not completed, popup note dialog for user to double confirm.
          if (!userInfo?.isCompleteInfo)
            await new Promise((resolve, reject) => {
              handleOpen()
              // async submission can block promise, so can save promise resolve and reject inside ref, execution them after dialog actions
              resolveRef.current = resolve
              rejectRef.current = reject
            })
          const { gender, userStatus, birthday } = values
          // phone and email field should not be updated by user info update api, they will be updated by other independent api.
          const pureValues = omit(
            {
              ...values,
              gender: Number(gender),
              userStatus: userStatus ? '1' : '0',
              isCompleteInfo: true,
              birthday: format(birthday, BIRTHDAY_FORMAT),
            },
            ['email', 'phone', 'dialingCode'],
          )
          await dispatch(updateUserInfo(pureValues)).unwrap()
          // resetForm can update the form's initialValues and set dirty true.
          actions.resetForm({ values })
          toast.success(t('tips.change_info_successfully'))
          handleConfirm(pureValues)
        }, 1000)}
      >
        {(props) => {
          const {
            values,
            // setValues,
            setFieldValue,
            touched,
            errors,
            handleChange,
            handleSubmit,
            // handleReset,
            dirty,
            setFieldTouched,
            isSubmitting,
            // resetForm,
            // initialValues,
          } = props

          useEffect(() => {
            if (fromOrder) {
              setFieldTouched('phone')
            }
          }, [])

          const isError = (field) => touched[field] && Boolean(errors[field])
          const errorText = (field) => touched[field] && errors[field]
          useTranslateFormErrors(errors, touched, setFieldTouched)

          // const onAccountUpdate = async (accountValues) => {
          //   resetForm({ values: { ...initialValues, ...accountValues } })
          //   setValues({ ...values, ...accountValues })
          // }
          return (
            <>
              <form className={classes.form} onSubmit={handleSubmit} noValidate>
                {/* show dialog before leaving page when form is dirty.  */}
                <Prompt when={dirty} message={t('are_you_sure.you_have_unsaved_form')} />
                <InputLabel shrink required className={classes.requiredText}>
                  {t('profile.required')}
                </InputLabel>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <InputLabel
                      shrink
                      required
                      classes={{ asterisk: classes.asterisk, root: classes.outlined }}
                    >
                      {t('form.en_name')}
                    </InputLabel>
                    <TextField
                      className={classes.textField}
                      // label={t('form.en_name')}
                      name="nameEn"
                      fullWidth
                      variant="outlined"
                      value={values.nameEn}
                      onChange={handleChange}
                      placeholder={t('form.en_name_default')}
                      type="text"
                      error={isError('nameEn')}
                      required
                      FormHelperTextProps={{
                        classes: {
                          root: classes.helperText,
                        },
                      }}
                      // disabled={userInfo?.isCompleteInfo}
                      helperText={isError('nameEn') ? errorText('nameEn') : t('common.must_same')}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel
                      shrink
                      required={values.identifyType === 0}
                      classes={{ asterisk: classes.asterisk, root: classes.outlined }}
                    >
                      {t('form.zh_name')}
                    </InputLabel>
                    <TextField
                      className={classes.textField}
                      // label={t('form.zh_name')}
                      name="nameCn"
                      fullWidth
                      variant="outlined"
                      value={values.nameCn}
                      onChange={handleChange}
                      placeholder={t('form.zh_name_default')}
                      type="text"
                      error={isError('nameCn')}
                      required={values.identifyType === 0}
                      disabled={userInfo?.isCompleteInfo}
                      helperText={isError('nameCn') ? errorText('nameCn') : t('common.must_same')}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel
                      shrink
                      required
                      classes={{ asterisk: classes.asterisk, root: classes.outlined }}
                    >
                      {t('form.id_type')}
                    </InputLabel>
                    <FormControl
                      variant="outlined"
                      className={classes.textField}
                      fullWidth
                      error={isError('identifyType')}
                      required
                    >
                      <Select
                        // native
                        labelId="identify-id-select-label"
                        id="identify-id-type-select"
                        name="identifyType"
                        // label={t('form.id_type')}
                        value={values.identifyType}
                        onChange={handleChange}
                        onBlur={() => {
                          if (values.identifyType === '0' && values.identifyId?.length === 18) {
                            setFieldValue(
                              'birthday',
                              parseValid(getBirthDate(values.identifyId), BIRTHDAY_FORMAT, new Date()),
                            )
                          }
                        }}
                        // input={<Input className={classes.inputBorder} />}
                        disabled={userInfo?.isCompleteInfo}
                        // IconComponent={() => <RightArrowIcon className={classes.arrowIcon} />}
                      >
                        {ID_TYPES.map((idType) => (
                          <MenuItem key={idType.value} value={idType.value}>
                            {t(idType.label)}
                          </MenuItem>
                        ))}
                      </Select>
                      {errorText('identifyType')}
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={values.identifyType === 3 ? 6 : 12}>
                    <InputLabel
                      shrink
                      required
                      classes={{ asterisk: classes.asterisk, root: classes.outlined }}
                    >
                      {t('form.id_number')}
                    </InputLabel>
                    <TextField
                      className={classes.textField}
                      // label={t('form.id_number')}
                      id="identify-id-field"
                      name="identifyId"
                      variant="outlined"
                      fullWidth
                      FormHelperTextProps={{
                        classes: {
                          root: classes.helperText,
                        },
                      }}
                      value={
                        userInfo?.isCompleteInfo
                          ? encryptId(values.identifyId, values.identifyType)
                          : values.identifyId
                      }
                      onChange={handleChange}
                      onInput={(e) => {
                        if (values.identifyType === 0 && e.target.value.length === 18) {
                          setFieldValue(
                            'birthday',
                            parseValid(getBirthDate(e.target.value), BIRTHDAY_FORMAT, new Date()),
                          )
                        }
                      }}
                      placeholder={identifyPlaceholder(values.identifyType)}
                      type="text"
                      error={isError('identifyId')}
                      required
                      // disabled={userInfo?.isCompleteInfo}
                      helperText={
                        isError('identifyId') ? errorText('identifyId') : t('tips.check_id_number_for_report')
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  {values.identifyType === 3 && (
                    <Grid item xs={6}>
                      <InputLabel
                        shrink
                        required
                        classes={{ asterisk: classes.asterisk, root: classes.outlined }}
                      >
                        {t('form.place_of_issue')}
                      </InputLabel>
                      <TextField
                        className={classes.textField}
                        // label={t('form.place_of_issue')}
                        id="place-of-issuance-field"
                        name="placeOfIssuance"
                        variant="outlined"
                        fullWidth
                        value={values.placeOfIssuance}
                        onChange={handleChange}
                        placeholder={t('validation.please_enter', { field: '$t(form.place_of_issue)' })}
                        type="text"
                        error={isError('placeOfIssuance')}
                        required={values.identifyType === 0 || values.identifyType === 3}
                        disabled={
                          (values.identifyType === 0 || values.identifyType === 3) && userInfo?.isCompleteInfo
                        }
                        helperText={errorText('placeOfIssuance')}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  )}
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <InputLabel
                      shrink
                      required
                      classes={{ asterisk: classes.asterisk, root: classes.outlined }}
                    >
                      {t('form.gender')}
                    </InputLabel>
                    <FormControl
                      className={classes.textField}
                      fullWidth
                      variant="outlined"
                      error={isError('gender')}
                      required
                    >
                      <Select
                        id="gender-radio"
                        aria-label="gender"
                        name="gender"
                        value={values.gender}
                        onChange={handleChange}
                        labelId="identify-id-select-label"
                      >
                        <MenuItem value="0">{t('form.male')}</MenuItem>
                        <MenuItem value="1">{t('form.female')}</MenuItem>
                      </Select>
                      {errorText('identifyType')}
                    </FormControl>
                  </Grid>
                </Grid>

                <Box my={2}>
                  <InputLabel
                    shrink
                    required
                    classes={{ asterisk: classes.asterisk, root: classes.outlined }}
                  >
                    {t('form.birthday')}
                  </InputLabel>
                  <CustomDatePicker
                    className={classes.CustomDatePicker}
                    // label={t('form.birthday')}
                    id="birthday-field"
                    name="birthday"
                    variant="dialog"
                    placeholder={t('form.birthday_default')}
                    openTo="year"
                    views={['year', 'month', 'date']}
                    format={BIRTHDAY_FORMAT}
                    value={values.birthday}
                    onChange={(date) => setFieldValue('birthday', date)}
                    shouldDisableDate={(day) => isAfter(day, new Date())}
                    maxDate={new Date()}
                    fullWidth
                    error={isError('birthday')}
                    required
                    // disabled={userInfo?.isCompleteInfo || values.identifyType === '0'}
                    helperText={errorText('birthday')}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      endAdornment: <DateRangeOutlinedIcon />,
                    }}
                    okLabel={t('common.confirm')}
                    cancelLabel={t('common.cancel')}
                  />
                </Box>

                {matches ? (
                  <FixedButtonWrapper>
                    <Box mt={1} mb={2}>
                      <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        disabled={!dirty || isSubmitting}
                        color="secondary"
                        className={classes.submitButton}
                      >
                        {updateUserInfoStatus === 'pending' ? (
                          <CircularProgress color="inherit" size={24} />
                        ) : (
                          t('common.confirm')
                        )}
                      </Button>
                    </Box>
                    <Box mb={2}>
                      <Button variant="outlined" fullWidth color="default" onClick={handleConfirm}>
                        {t('common.cancel')}
                      </Button>
                    </Box>
                  </FixedButtonWrapper>
                ) : (
                  <>
                    <Box mt={1} mb={2}>
                      <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        disabled={!dirty || isSubmitting}
                        color="secondary"
                        className={classes.submitButton}
                      >
                        {updateUserInfoStatus === 'pending' ? (
                          <CircularProgress color="inherit" size={24} />
                        ) : (
                          t('common.confirm')
                        )}
                      </Button>
                    </Box>
                    <Button variant="outlined" fullWidth color="default" onClick={handleConfirm}>
                      {t('common.cancel')}
                    </Button>
                  </>
                )}

                <FocusError />
              </form>
              <Dialog fullWidth maxWidth="sm" open={open} onClose={handleCancelSubmit}>
                <DialogTitle
                  id="cancel-order-dialog"
                  style={{
                    textAlign: 'center',
                    color: '#111',
                    background: '#fff',
                    borderBottom: '1px solid #E5E7EB',
                  }}
                >
                  {t('tips.main_tips')}
                </DialogTitle>
                <DialogContent>
                  <Typography component="div">
                    <Box fontSize="body1.fontSize" color="secondary.main" my={1}>
                      {t('tips.check_account_info')}
                    </Box>
                    <Box fontSize="body2.fontSize" fontWeight="fontWeightBold">
                      {t('form.name')}: {values.nameEn || values.nameCn}
                      <br />
                      {t('form.id_number')}: {values.identifyId}
                      <br />
                      {t('form.birthday')}:{' '}
                      {isValid(values.birthday) && format(values.birthday, BIRTHDAY_FORMAT)}
                      {/* <br /> {t('form.phone')}:{' '}
                      {values.phone ? formatDialingCode(values.dialingCode) + values.phone : ''}
                      <br /> {t('form.email')}: {values.email} */}
                    </Box>
                  </Typography>
                </DialogContent>
                <DialogActions>
                  <Button variant="text" color="default" onClick={handleCancelSubmit}>
                    {t('common.back')}
                  </Button>
                  <Button type="submit" variant="contained" color="secondary" onClick={handleResolveSubmit}>
                    {t('common.confirm')}
                  </Button>
                </DialogActions>
              </Dialog>
            </>
          )
        }}
      </Formik>
    </>
  )
}

export default UserInfoForm
